import { render } from "./question.vue?vue&type=template&id=069b12ad"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
script.render = render

export default script